export default __webpack_public_path__ + "static/media/thanku-confirm.f2b94ece.svg";